import React from 'react';
import './TextButton.scss'
import ITextButtonProps from "../../interfaces/itext_button_props.type";

const TextButton: React.FunctionComponent<ITextButtonProps> = ({
        disabled = false,
        variant = 'primary',
        handleClick = () => {},
        buttonText = 'Button',
        testId = 'text-button',
        type = 'button'
}) => {
    return(
        <button
            type={type}
            data-testid={testId}
            disabled={disabled}
            className={variant}
            onClick={handleClick}
        >
            {buttonText}
        </button>
    )
}

export default TextButton

